import Marquee from "react-fast-marquee";

const ITEMS = ["zang & gitaar", "eigen werk", "stilte", "verhalen", "nederlandstalig", "akoestisch"];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="py-12 sm:py-16 border-y border-sand-200 overflow-hidden bg-sand-100/60">
    <Marquee speed={25} gradient={false} pauseOnHover>
      {ITEMS.map((t) => (
        <span key={t} className="flex items-center font-serif italic font-light text-4xl sm:text-6xl text-rose-300 mx-6">
          {t}
          <span className="not-italic text-2xl sm:text-3xl text-terracotta-500 ml-12 mr-6">·</span>
        </span>
      ))}
    </Marquee>
  </div>
);
